import React, { memo } from "react";

import lbl from "../../data/Labels.json";

import GraduateIcon from "../../icons/graduate-icon";
import StudyingIcon from "../../icons/studying-icon";
import ActiveYearsIcon from "../../icons/active-years-icon";
import FailedIcon from "../../icons/failed-icon";
import PassedIcon from "../../icons/passed-icon";
import StudentIcon from "../../icons/student-icon";
import StateIcon from "../../icons/state-icon";
import TeacherIcon from "../../icons/teacher-icon";

const ListStats = ({ stats }) => {
  const renderStatData = (title) => {
    switch (title) {
      case "active":
        return { title: lbl.Active, icon: <StudyingIcon /> };
      case "graduates":
        return { title: lbl.Graduates, icon: <GraduateIcon /> };
      case "years":
        return { title: lbl.Years, icon: <ActiveYearsIcon /> };
      case "class_status":
        return { title: lbl.ClassStatus, icon: <StateIcon /> };
      case "failed":
        return { title: lbl.Failed, icon: <FailedIcon /> };
      case "passed":
        return { title: lbl.Passed, icon: <PassedIcon /> };
      case "student_count":
        return { title: lbl.StudentCount, icon: <StudentIcon /> };
      case "disqualified":
        return { title: lbl.Disqualified, icon: <ActiveYearsIcon /> };
      case "teacher_name":
        return { title: lbl.Teacher, icon: <TeacherIcon /> };
      default:
        return { title: lbl.Undefind };
    }
  };

  const renderStatItem = (p = new Object()) => {
    return (
      <div className="list-stat-item" key={Math.random()}>
        <div className="wrapper">
          <div className="content">
            <span>
              <p>{p.title}</p>
              <b>{p.state}</b>
            </span>
          </div>
          <div className="icon">{p.icon}</div>
        </div>
      </div>
    );
  };

  return stats ? (
    <div className="list-stats">
      {Object.keys(stats).map(
        (stat) =>
          stat !== "title" &&
          renderStatItem({
            title: renderStatData(stat)?.title,
            icon: renderStatData(stat)?.icon,
            state: stats[stat],
          })
      )}
    </div>
  ) : null;
};

export default ListStats;
